var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-text-field', _vm._b({
    attrs: {
      "value": _vm.text,
      "suffix": _vm.suffixText,
      "disabled": _vm.disabled,
      "label": _vm.label,
      "error-messages": _vm.errorMessages,
      "type": "text",
      "inputmode": "decimal",
      "autocomplete": "off"
    },
    on: {
      "input": _vm.onInput,
      "focus": _vm.onFocus,
      "blur": _vm.onBlur,
      "keydown": function keydown($event) {
        return _vm.$emit('keydown', $event);
      }
    }
  }, 'v-text-field', _vm.$attrs, false));

}
var staticRenderFns = []

export { render, staticRenderFns }